// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b5-3";
export var contentContainer = "_b5-0";
export var editorContainer = "_b5-1";
export var quillInputForm = "_b5-2";
export var zoneDivider = "_b5-4";